<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container big-container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Finance</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Invoice
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Invoices <span><i class="ic-office"></i></span>
                  </h2>
                  <p>Manage and view all invoices.</p>
                </div>
                <router-link to="/finance/invoice/receive-payment">
                  <button
                    class="btn btn-primary pull-right"
                    style="margin-right: 80px"
                  >
                    Receive Payment
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container big-container">
        <div class="row mb-20">
          <div class="col-sm-4">
            <label for="search">Search</label>
            <div class="dataTables_filter" id="filter-search">
              <i class="ic-search"></i>
              <input
                id="search"
                type="search"
                class="form-control"
                placeholder="Search"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <label for="company">Company</label>
            <v-select
              @input="getListInvoices()"
              class="v-search-select"
              id="company"
              placeholder="Company"
              label="name"
              v-model="table.companyIds"
              :options="companyOptions"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.id"
            />
          </div>
          <div class="col-sm-4">
            <label for="">Date</label>
            <div class="dataTables_filter">
              <VueCtkDateTimePicker
                id="invoiceDateRange"
                name="invoiceDateRange"
                v-model="table.invoiceDate"
                color="#025BC5"
                format="YYYY-MM-DD"
                formatted="MMM DD, YYYY"
                range
                auto-close
                no-label
                no-shortcuts
                no-header
                overlay
                no-button-now
                button-color="#FFB733"
                @input="changeInvoiceDate()"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="dataTables_length">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-p15">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="text-center">No</th>
                  <th class="text-left">
                    Date
                    <span class="button-sort" @click="onClickSort('date')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th class="text-left">
                    Invoice Number
                    <span class="button-sort" @click="onClickSort('number')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th class="text-left">Customer</th>
                  <th class="text-right">Total</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val, index) in invoiceList" :key="index">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-left">{{ val.invoiceDate }}</td>
                  <td class="text-left">{{ val.number }}</td>
                  <td class="text-left">
                    <div class="invoice-customer-box">
                      <div class="invoice-company-text">
                        {{ val.billingInfo.company }}
                      </div>
                      <span
                        class="invoice-customer-text"
                        v-html="formattedDescription(val.billTo)"
                      ></span>
                    </div>
                  </td>
                  <td class="text-right">
                    {{ val.currency }}
                    {{ $currencyFormat(val.currency, val.amount) }}
                  </td>
                  <td class="text-right">
                    <div class="dropdown">
                      <button
                        class="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <img
                          src="/static/assets/images/three-dots.svg"
                          alt="three-dots-options"
                          width="15"
                        />
                      </button>
                      <ul
                        class="dropdown-menu dropdown-invoice-options"
                        aria-labelledby="dropdownMenu1"
                      >
                        <li>
                          <router-link
                            :to="`/finance/invoice/edit-invoice/${val.id}`"
                          >
                            Edit
                          </router-link>
                        </li>
                        <li
                          v-if="val.status === 'Unpaid'"
                          style="
                            min-width: max-content !important;
                            cursor: pointer;
                          "
                          @click="openModal(val.id)"
                        >
                          <a>Mark as Paid</a>
                        </li>
                        <li
                          v-if="!val.isPosted"
                          style="
                            min-width: max-content !important;
                            cursor: pointer;
                          "
                          @click="postToQuickBooks(val.id)"
                        >
                          <a>Post to QuickBooks</a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <div class="modal fade" role="dialog" ref="mark_as_paid_modal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Mark as Paid</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submitMarkAsPaid">
                    <div class="form-group">
                      <label class="required" for="mutation-start-pickup"
                        >Payment Date</label
                      >
                      <div class="dataTables_filter">
                        <i class="ic-date-picker"></i>
                        <VueCtkDateTimePicker
                          v-model="model.paymentDate"
                          id="mutation-start-pickup"
                          color="#025BC5"
                          no-label
                          no-header
                          no-button
                          no-button-now
                          format="YYYY-MM-DDTHH:mm"
                          formatted="MMM DD, YYYY HH:mm"
                        />
                      </div>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.paymentDate.required"
                        style="display: block"
                      >
                        Payment date is required
                      </small>
                    </div>
                    <div class="form-group">
                      <label class="required" for="payment_id"
                        >Payment ID</label
                      >
                      <input
                        id="payment_id"
                        type="text"
                        class="form-control"
                        v-model="model.refPaymentId"
                      />
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.refPaymentId.required"
                        style="display: block"
                      >
                        Payment ID is required
                      </small>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Mark as Paid
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import invoiceService from "@/services/shop/invoiceService.js";
import companyService from "@/services/master/company/companyService.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSync: function () {
      return this.allPermissions.includes("Sync");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        invoiceDate: {
          start: "",
          end: "",
        },
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "date",
        sortDir: "desc",
      },
      invoiceList: [],
      typeOptions: [
        { value: "All", text: "All" },
        { value: "Corp. Admin", text: "Corp. Admin" },
        { value: "Corp. Booker", text: "Corp. Booker" },
        { value: "Corp. Customer", text: "Corp. Customer" },
      ],
      companyOptions: [],
      isSubmitted: false,
      isUpdate: false,
      isLoading: false,
      selectedInvoiceId: "",
      model: {
        paymentDate: null,
        refPaymentId: "",
      },
      msg: "Please wait",
    };
  },
  validations() {
    const v = {
      model: {
        refPaymentId: { required },
        paymentDate: { required },
      },
    };

    return v;
  },
  async created() {
    this.$helper.scrollTop();
    await this.getListInvoices();
    await this.getCompanies();
  },
  methods: {
    formattedDescription(value) {
      return value.replace(/\n/g, "<br>");
    },
    closeModal() {
      $(this.$refs.mark_as_paid_modal).modal("hide");
      this.selectedInvoiceId = "";
      this.model = {
        paymentDate: null,
        refPaymentId: "",
      };
    },
    openModal(id) {
      this.selectedInvoiceId = id;
      $(this.$refs.mark_as_paid_modal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async submitMarkAsPaid() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }
      try {
        this.isLoading = true;
        let paymentDate = null;

        if (this.model.paymentDate) {
          paymentDate = this.model.paymentDate + ":00";
        }
        const payload = {
          invoiceId: this.selectedInvoiceId,
          refPaymentId: this.model.refPaymentId,
          paymentDate: paymentDate,
        };

        const response = await invoiceService.markAsPaid(
          this.selectedInvoiceId,
          payload
        );

        if (response.isSuccess) {
          this.$notification.success("Mark as paid successfully", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.isSubmitted = false;
        this.getListInvoices();
        this.closeModal();
      }
    },
    async changeInvoiceDate() {
      if (
        this.table.invoiceDate &&
        this.table.invoiceDate.start &&
        this.table.invoiceDate.end
      ) {
        await this.getListInvoices();
      } else if (!this.table.invoiceDate) {
        await this.getListInvoices();
      }
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getListInvoices();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getListInvoices();
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getListInvoices();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getListInvoices();
    },
    async getListInvoices() {
      try {
        this.isLoading = true;
        let params = `page=${this.table.pageNumber}&pageSize=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          params += `&keyword=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          params += `&sortBy=${this.table.sort}&sortDirection=${this.table.sortDir}`;
        }
        if (this.table.companyIds && this.table.companyIds !== "") {
          params += `&companyIds=${this.table.companyIds}`;
        }
        if (this.table.invoiceDate.start && this.table.invoiceDate.end) {
          params += `&fromDate=${this.table.invoiceDate.start}&toDate=${this.table.invoiceDate.end}`;
        }
        const response = await invoiceService.getListInvoices(params);

        if (response.isSuccess) {
          this.invoiceList = response.data.items;
          this.table.totalPages = response.data.totalPages;
          this.table.totalRecords = response.data.totalItems;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCompanies() {
      this.companyOptions = await companyService.getAllActive();
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getListInvoices();
    },
    async postToQuickBooks(invoiceId) {
      this.isLoading = true;
      try {
        const payload = {
          invoiceId: invoiceId,
        };

        const response = await invoiceService.postToQBO(payload);

        if (response.isSuccess) {
          this.$notification.success("Success post to QuickBooks.", {
            title: "Success",
          });
          await this.getListInvoices();
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  updated() {
    // subscribe message
    this.$helper.collapseMenu("deposit");
    this.$helper.setNavigationClass("invoice-link");
  },
};
</script>
<style scoped>
.invoice-customer-box {
  display: flex;
  flex-direction: column;
}

.invoice-company-text {
  font-weight: 700;
}

.invoice-customer-text {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/InvoiceList.vue